import React from 'react';
import { useApiLoading } from 'react-reqq-lite';
import * as c from './constants';
import * as actions from './actions';

export const useSendCode = () => {
  const isApiLoading = useApiLoading(c.SEND_CODE, 'post');
  const sendCode = React.useCallback((payload, callback) => {
    actions.sendCode(payload, callback);
  }, []);
  return [isApiLoading, sendCode];
};
